import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import withStyles from '@material-ui/core/styles/withStyles';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import styles from './NavElement.style';

class NavElement extends PureComponent {
  render() {
    const { classes, url, label, description, children } = this.props;
    return (
      <Link to={url}>
        <ButtonBase className={classes.root} component='div'>
          <div className={classes.textContainer}>
            <Typography className={classes.label}>
              {label}
            </Typography>
            {/* <Typography className={classes.description}>
              {description}
            </Typography> */}
          </div>
          <div className={classes.iconContainer}>
            <ArrowDropDownIcon className={classes.icon} />
          </div>
        </ButtonBase>
      </Link>
    )
  }
}

export default withStyles(styles)(NavElement)